import { InputNumber } from "primereact/inputnumber";
import AuthContext from "../../../../auth/AuthContext";
import PracticalExamService from "../../../../services/PracticalExamService";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";

const ViewPracticalExamQuestion = ({ input, changeHandler }) => {
    const storyBoardTitle = input && input.storyBoardTitle;
    const storyBoardInfo = input && input.storyBoardInfo;
    const taskTitle = input && input.taskTitle;
    const taskInfo = input && input.taskInfo;
    const fileName = input && input.fileName;
    let answer = input && input.answer;
    const [href, setHref] = useState();
    const [score, setScore] = useState(input && input.score);
    const [comment, setComment] = useState(input && input.comments);
    const [fileNotFound, setFileNotFound] = useState(false);

    if (answer === undefined || answer === null || answer === '') {
        answer = "<center>[Empty]</center>";
    }

    const authContext = useContext(AuthContext);

    const loadDocument = useCallback(async () => {
        setFileNotFound(false);
        if (fileName && fileName !== "") {
            let data = await PracticalExamService.GetFile(input.answerId, authContext);
            if (data.isSuccess && data.data && data.data != null) {
                setHref(`data:${data.data.contentType};base64,${data.data.filePath}`);
            } else {
                setFileNotFound(true);
            }
        }
    }, [authContext, input.answerId, fileName]);

    useEffect(() => {
        loadDocument();
    }, [authContext, loadDocument, input.answerId]);

    useEffect(() => {
        setScore(input && input.score);
        setComment(input && input.comments);
    }, [input]);

    return (
        <Fragment>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className=" pb-2" style={{ color: '#0F75BC' }}>{storyBoardTitle}</label>
                <div>{storyBoardInfo}</div>
            </div>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className="pb-2" style={{ color: '#0F75BC' }}>{taskTitle}</label>
                <div>{taskInfo}</div>
            </div>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className="pb-2" style={{ color: '#0F75BC' }}>Answer</label>
                <div
                    className="border p-2 rounded-2"
                    style={{ overflow: 'hidden' }}
                    dangerouslySetInnerHTML={{
                        __html: answer.replace(
                            /<img/g,
                            '<img style="max-width:100%;height:auto;display:block;"'
                        )
                    }}
                ></div>
            </div>

            <hr />
            <div className="d-flex flex-column">
                <label className=" pb-2" style={{ color: '#0F75BC' }}>Score</label>
                <div style={{ width: '100%' }} className="pb-2">
                    <InputNumber
                        inputId="integeronly"
                        maxFractionDigits={2}
                        minFractionDigits={2}
                        useGrouping={false}
                        min={0}
                        placeholder="Score"
                        max={100.0}
                        maxLength={3}
                        format={false}
                        value={score}
                        onValueChange={(e) => {
                            setScore(e.value);
                            changeHandler(input.id, e.value, comment);
                        }}
                        style={{ width: '100%' }}
                        inputStyle={{ width: '100%' }}
                        className="custom-input"
                    />
                </div>

            </div>
            <hr />
            <div className="d-flex flex-column ">
                <label className="pb-2" style={{ color: '#0F75BC' }}>Comment</label>
                <div className="pb-2">
                    <textarea
                        placeholder="Comments"
                        className="form-control no-resize cancel-reason custom-input-color"
                        maxLength={500}
                        defaultValue={comment}
                        onChange={(e) => {
                            setComment(e.target.value);
                            changeHandler(input.id, score, e.target.value);
                        }}
                    ></textarea>
                </div>
            </div>
            <hr />
            {fileName && fileName !== "" && (<>
                <div className="d-flex flex-column ms-3">
                    <label className="pb-2" style={{ color: '#0F75BC' }}>Attachments</label>
                    <div className="row m-0 pl-3 pr-3">
                        <div className="col-10 value document-files">
                            <div className="attachment-container">
                                <div className="file">
                                    <a href={href} download={fileName}>
                                        {fileName}
                                    </a>{" "}
                                    {fileNotFound && <span className="text-danger">( File not found )</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </>
            )}
        </Fragment>
    );
};

export default ViewPracticalExamQuestion;
